module.exports = __webpack_public_path__ + "catalog/items/outdoor/parasol/parasol.svg";